import type { ChangeEvent } from 'react';

import { maskitoDateOptionsGenerator } from '@maskito/kit';
import { forwardRef } from 'react';

import { type MaskFieldProps, MaskField } from './MaskField';

interface DobFieldProps extends Omit<MaskFieldProps, 'mask' | 'onChange'> {
  onChange?: (value: string) => void;
}

export const DobField = forwardRef<HTMLInputElement, DobFieldProps>((props, ref) => {
  const options = maskitoDateOptionsGenerator({ mode: 'dd/mm/yyyy', separator: '-' });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(e.target.value);
  };

  return <MaskField maskitoOptions={options} {...props} ref={ref} onChange={handleChange} />;
});
